import React from "react";
import "./FloatingSocial.css";

const SOCIALS = [
  { label: "Instagram", icon: "IG", href: "https://www.instagram.com/ajera_infotech?igsh=MTV1dDE1bTVmbG1ueQ==", color: "#E1306C", bg: "rgba(225,48,108,0.15)" },
  { label: "WhatsApp",  icon: "WA", href: "https://wa.me/919751772429",    color: "#25D366", bg: "rgba(37,211,102,0.15)" },
  { label: "LinkedIn",  icon: "IN", href: "https://www.linkedin.com/company/ajera-infotech/", color: "#0A66C2", bg: "rgba(10,102,194,0.15)" },
  // { label: "YouTube",   icon: "YT", href: "https://youtube.com/@ajerait",  color: "#FF0000", bg: "rgba(255,0,0,0.15)" },
];

const FloatingSocial: React.FC = () => (
  <div className="fsocial">
    {SOCIALS.map((s) => (
      <a
        key={s.label}
        href={s.href}
        target="_blank"
        rel="noopener noreferrer"
        className="fsocial__item"
        aria-label={s.label}
        style={{ "--sc": s.color, "--sbg": s.bg } as React.CSSProperties}
      >
        <span className="fsocial__icon">{s.icon}</span>
        <span className="fsocial__label">{s.label}</span>
      </a>
    ))}
  </div>
);

export default FloatingSocial;
